import { render, staticRenderFns } from "./OrderCantServe.vue?vue&type=template&id=395f81fe&scoped=true"
import script from "./OrderCantServe.vue?vue&type=script&lang=js"
export * from "./OrderCantServe.vue?vue&type=script&lang=js"
import style0 from "./OrderCantServe.vue?vue&type=style&index=0&id=395f81fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395f81fe",
  null
  
)

export default component.exports